import axios from 'axios';
import { authMsg } from '../../utils/auth';
import { getCommonError } from '../../utils';

/*** TYPES ***/
const AUDIT_UNIVERSE_LOADING = 'AUDIT_UNIVERSE_LOADING';
const AUDIT_UNIVERSE_DATA = 'AUDIT_UNIVERSE_DATA';
const AUDIT_SINGLE_STATUS_LOADING = 'AUDIT_SINGLE_STATUS_LOADING';
const AUDIT_SINGLE_STATUS_DATA = 'AUDIT_SINGLE_STATUS_DATA';
const AUDIT_UNRESOLVED_LOADING = 'AUDIT_UNRESOLVED_LOADING';
const AUDIT_UNRESOLVED_DATA = 'AUDIT_UNRESOLVED_DATA';
const AUDIT_ORPHAN_SINGLES_LOADING = 'AUDIT_ORPHAN_SINGLES_LOADING';
const AUDIT_ORPHAN_SINGLES_DATA = 'AUDIT_ORPHAN_SINGLES_DATA';

/*** REDUCER ***/
const initialState = {
  universeLoading: false,
  universe: null,
  singleStatusLoading: false,
  singleStatus: null,
  unresolvedLoading: false,
  unresolved: null,
  orphanSinglesLoading: false,
  orphanSingles: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case AUDIT_UNIVERSE_LOADING:
      return { ...state, universeLoading: action.payload };
    case AUDIT_UNIVERSE_DATA:
      return { ...state, universe: action.payload };

    case AUDIT_SINGLE_STATUS_LOADING:
      return { ...state, singleStatusLoading: action.payload };
    case AUDIT_SINGLE_STATUS_DATA:
      return { ...state, singleStatus: action.payload };

    case AUDIT_UNRESOLVED_LOADING:
      return { ...state, unresolvedLoading: action.payload };
    case AUDIT_UNRESOLVED_DATA:
      return { ...state, unresolved: action.payload };

    case AUDIT_ORPHAN_SINGLES_LOADING:
      return { ...state, orphanSinglesLoading: action.payload };
    case AUDIT_ORPHAN_SINGLES_DATA:
      return { ...state, orphanSingles: action.payload };

    default:
      return state;
  }
}

/*** ACTIONS ***/

export function getAuditUniverseBreakdown() {
  return async (dispatch) => {
    try {
      dispatch({ type: AUDIT_UNIVERSE_LOADING, payload: true });
      const response = await axios.get('/admin/audit/universe');
      dispatch({ type: AUDIT_UNIVERSE_DATA, payload: response.data });
      dispatch({ type: AUDIT_UNIVERSE_LOADING, payload: false });
    } catch (error) {
      dispatch({ type: AUDIT_UNIVERSE_LOADING, payload: false });
      authMsg('error', getCommonError(error));
    }
  };
}

export function getAuditSingleStatusCounts() {
  return async (dispatch) => {
    try {
      dispatch({ type: AUDIT_SINGLE_STATUS_LOADING, payload: true });
      const response = await axios.get('/admin/audit/single-status');
      dispatch({ type: AUDIT_SINGLE_STATUS_DATA, payload: response.data });
      dispatch({ type: AUDIT_SINGLE_STATUS_LOADING, payload: false });
    } catch (error) {
      dispatch({ type: AUDIT_SINGLE_STATUS_LOADING, payload: false });
      authMsg('error', getCommonError(error));
    }
  };
}

export function getAuditInspectUnresolved() {
  return async (dispatch) => {
    try {
      dispatch({ type: AUDIT_UNRESOLVED_LOADING, payload: true });
      const response = await axios.get('/admin/audit/inspect/unresolved');
      dispatch({ type: AUDIT_UNRESOLVED_DATA, payload: response.data });
      dispatch({ type: AUDIT_UNRESOLVED_LOADING, payload: false });
    } catch (error) {
      dispatch({ type: AUDIT_UNRESOLVED_LOADING, payload: false });
      authMsg('error', getCommonError(error));
    }
  };
}

export function getAuditInspectOrphanSingles() {
  return async (dispatch) => {
    try {
      dispatch({ type: AUDIT_ORPHAN_SINGLES_LOADING, payload: true });
      const response = await axios.get('/admin/audit/inspect/orphan-singles');
      dispatch({ type: AUDIT_ORPHAN_SINGLES_DATA, payload: response.data });
      dispatch({ type: AUDIT_ORPHAN_SINGLES_LOADING, payload: false });
    } catch (error) {
      dispatch({ type: AUDIT_ORPHAN_SINGLES_LOADING, payload: false });
      authMsg('error', getCommonError(error));
    }
  };
}
